import styled, { css } from 'styled-components'
import { rem } from 'utils/common'
import { device, merchantThemes } from 'components/Variable'

export const ReturnItemStyle = styled.div`
	padding: ${rem(14)};
	display: flex;
	flex-flow: row wrap;
	align-items: center;
	background-color: ${({ theme }) => theme.color.secondary};
	border-bottom: 1px solid ${({ theme }) => theme.color.grayOne};
	color: ${({ theme }) => theme.color.blackOne};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			border-bottom: 1px solid ${({ theme }) => theme.color.primary};
		`}

	&:last-child {
		border-bottom: 0;
	}
	${(p) =>
		p.returned &&
		css`
			color: ${({ theme }) => theme.color.grayFour};
		`}
`
export const StatusIcon = styled.div`
	flex: 0 0 ${rem(56)};
	max-width: ${rem(56)};
	height: 100%;
	display: flex;
	justify-content: center;
	align-items: center;

	@media (${device.tablet}) {
		flex: 0 0 ${rem(32)};
		max-width: ${rem(32)};
	}

	> svg {
		&.returned {
			width: ${rem(32)};
			height: ${rem(32)};

			@media (${device.tablet}) {
				flex: 0 0 ${rem(24)};
				max-width: ${rem(24)};
				height: ${rem(24)};
			}
		}

		&.pending {
			width: ${rem(32)};
			height: ${rem(32)};

			transform: scale(1.35) translate(4px, 4px);

			@media (${device.tablet}) {
				> path {
					transform: scale(0.8) translate(4px, 4px);
				}
			}
		}

		cursor: pointer;
	}
`
export const Preview = styled.div`
	height: ${rem(80)};
	flex: 0 0 ${rem(80)};
	max-width: ${rem(80)};
	margin: ${rem(0, 14)};

	@media (${device.tablet}) {
		height: ${rem(56)};
		flex: 0 0 ${rem(56)};
		max-width: ${rem(56)};
	}

	img {
		display: block;
		object-fit: cover;
		max-width: 100%;
		height: 100%;
		border-radius: ${rem(3)};
	}

	${(p) =>
		p.returned &&
		css`
			img {
				opacity: 0.5;
			}
		`}
`
export const Body = styled.div`
	flex: 1 0;
	font-weight: 600;

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
		`}
`
export const Price = styled.div`
	font-weight: 700;
	font-size: ${rem(18)};
	line-height: ${rem(25)};
	letter-spacing: ${rem(0.257143)};
	padding-right: ${rem(27)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
			letter-spacing: ${rem(0.06)};
		`}

	@media (${device.tablet}) {
		font-size: ${rem(14)};
		line-height: ${rem(18)};
		padding-right: 0;
	}
`
export const Name = styled.h2`
	font-size: ${rem(16)};
	line-height: ${rem(22)};
	margin-bottom: ${rem(3)};

	${(p) =>
		p.theme.name === merchantThemes.toteme &&
		css`
			font-weight: normal;
		`}

	@media (${device.tablet}) {
		font-size: ${rem(14)};
		line-height: ${rem(18)};
	}
`

export const Status = styled.div`
	padding-top: ${rem(5)};
	font-size: ${rem(12)};
	line-height: ${rem(16)};
	font-style: italic;
	@media (${device.tablet}) {
		font-size: ${rem(12)};
		padding-top: 0;
	}
`
export const Checker = styled.div`
	flex: 0 0 ${rem(32)};
	max-width: ${rem(32)};
	height: ${rem(32)};
	border-radius: 50%;
	cursor: pointer;
	background: transparent;
	transition: all 0.3s;
	@media (${device.tablet}) {
		flex: 0 0 ${rem(24)};
		max-width: ${rem(24)};
		height: ${rem(24)};
	}

	&.empty-status {
		border: ${rem(1)} solid ${({ theme }) => theme.color.grayFour};
	}
`
export const CheckerTrue = styled(Checker)`
	> svg {
		width: ${rem(32)};
		height: ${rem(32)};

		@media (${device.tablet}) {
			> path {
				transform: scale(0.8) translate(1px, 4px);
			}
		}
	}
`
export const Flow = styled.div`
	position: relative;
	flex: 0 0 100%;
	max-width: 100%;
	transition: max-height 0.3s;
	overflow: hidden;
	padding: 0 1px;
	max-height: 0;
	${(p) =>
		p.checker &&
		css`
			max-height: 200px;
		`}
`
export const ButtonFlowWrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`
export const NoPreview = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	background-color: ${({ theme }) => theme.color.grayEleven};
	border-radius: ${rem(2)};
`
export const ButtonSelectedFlow = styled.div`
	margin-bottom: 0;

	&.flow-btn-selected {
		background-color: ${({ theme }) =>
			theme.color.flowButtonSelectedBgColor};
		border-color: ${({ theme }) =>
			theme.color.flowButtonSelectedBorderColor};
		color: ${({ theme }) => theme.color.flowButtonSelectedTextColor};
	}
`
